<template>
  <div class="title">
    <slot />
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.title {
  background-image: url(@images/titleBg.png);
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  background-position: center;
  padding-block: 50px;

  color: $white;
  text-align: center;
  font-size: 72px;
  font-weight: 600;
  line-height: 80px;
}

@media (max-width: 750px) {
  .title {
    padding-block: 30px;
    font-size: 48px;
    line-height: 52px;
  }
}
</style>e